module.exports = __webpack_public_path__ + "img/405.3b0e315a.jpg";